import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { always, ifElse, propEq } from 'ramda';

import { COLORS } from '@theme/colors';
import { slickStyles } from '@components/common/slick.styles';

export const Container = styled.div`
  position: fixed;
  width: 100vw;
  height: var(--vh);
  z-index: 6;
  left: 0;
  top: 0;
  background-color: ${COLORS.WHITE};
`;

const getControlsPanelPosition = ifElse(
  propEq('isMobile', true),
  always(
    css`
      bottom: calc(34px / 4);
    `
  ),
  always(
    css`
      top: calc(34px / 4);
    `
  )
);

export const ControlsPanel = styled.div<{ isMobile: boolean }>`
  background-color: ${COLORS.WILD_SAND};
  position: absolute;
  ${getControlsPanelPosition}
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  z-index: 2;

  svg {
    cursor: pointer;
  }
`;

export const ImageCounter = styled.div`
  min-width: 44px;
  height: 34px;

  color: ${COLORS.BLACK};
  padding: 9px 0 0 14px;
`;

export const ImageElement = styled(motion.img)`
  display: inline-block;
  transform-origin: top center;
  object-fit: contain;
  pointer-events: none;
  margin: 0 auto;
`;

export const ImagesContainer = styled(motion.div)<{ isZoom: boolean }>`
  display: inline-block;
  margin-top: 60px;
  width: 100%;
  cursor: ${({ isZoom }) => (isZoom ? 'zoom-out' : 'zoom-in')};

  ${slickStyles};
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
`;

export const ScrollContainer = styled.div`
  height: 100%;
  position: relative;
  text-align: center;
  overflow: auto;
`;

export const Button = styled.button`
  padding: 0;
  margin: 0;
  font-size: 0;
`;
